<template>
  
  <div v-if="isMobile==false" id="home" :style="{ 'background-image': 'url(' + backgroundImageSrc + ')', 'background-size':'cover'}">
    <header v-show="$route.path !== '/'" class="header">
      
      <div class="headerTitle" :style="{ 'background-image': 'url(' + titleImageSrc + ')','background-repeat':'no-repeat', 'background-color': backgroundColor,}"></div>
      
      <div class="headerNav" :style="{ 'background-color': backgroundColor, 'background-size':'cover' }">
      <nav>
        <ul  class="b">
          <li v-show="store.getters.getRole=='IP4'"><a href="#" @click="trasPage('registNotice')">お知らせ登録</a></li>
          <li v-show="store.getters.getRole=='IP4'"><a href="#" @click="trasPage('sendMail')">メール配信</a></li>
          <li v-show="store.getters.getRole=='IP4'"><a href="#" @click="trasPage('accountList')">ユーザ</a></li>
          <li v-show="store.getters.getRole=='IP4'"><a href="#" @click="trasPage('catalogList')">カタログ</a></li>
          <li><a href="#" @click.prevent.stop="viewChangePassword">パスワード変更</a></li>
          <li><a href="#" @click.prevent.stop="logout">ログアウト</a></li>
        </ul>
      </nav>
      </div>
      
	<div v-show="isEdit" style="position:absolute;  left:  800px; top: 0px;border :solid 2px; padding:10px;max-height:270px;width:400px;background:#fff;">
		<PasswordChange v-if="isEdit == true"  @setIsEdit="setIsEdit" ref="editCatalogComp"></PasswordChange>
	</div>
      
    </header>
    
    <router-view/>
    
    <footer v-show="$route.path !== '/'" :style="{ 'background-color': backgroundColor, 'background-size':'cover' }">
      <div style="text-align:left;padding-left:100px;">
      <a href="https://www.ip4.co.jp/" target="_blank">
        <img v-show="store.getters.getRole=='IP4'" src="./assets/IP4_white.png">
        <img v-show="store.getters.getRole=='guest'" src="./assets/IP4.png">
      </a>
      <a href="https://fans.co.jp/" target="_blank" >
        <img src="./assets/ss_white.png">
      </a>
      <a href="https://twitter.com/ip4_cpsl" target="_blank">
        <img v-show="store.getters.getRole=='IP4'" src="./assets/twitter.png" style="margin-left:600px;">
        <img v-show="store.getters.getRole=='guest'" src="./assets/twitter.png" style="margin-left:600px;">
      </a>
      <a href="https://www.instagram.com/ip4_official/" target="_blank">
      <img src="./assets/insta.png">
      </a>
      </div>
    </footer>
  </div>
</template>

<script>

import accountRepository from './composables/AccountRepository'
import { useStore } from 'vuex'
import { ref } from 'vue'
import { useRouter  } from 'vue-router'
import PasswordChange from './components/PasswordChange'

export default ({
  name: 'App',
  components:{PasswordChange},
  setup(){
  
    document.title = "KOROKORO MAGAZINE";
    const isEdit = ref(false)
    const { logoutAccount } = accountRepository()
    const backgroundImageSrc = ref( require('./assets/user.jpg') )
    const backgroundColor = ref(null)
    const titleImageSrc = ref( require('./assets/korokoro_user.png') )
    //Vuex使用変数宣言
    const store = useStore()
    const router = useRouter()
    
    const isMobile = ref( false )
    
      var userAgent = window.navigator.userAgent.toLowerCase();
      if ( 
          userAgent == null ||
          userAgent.indexOf("iphone") != -1 ||
          userAgent.indexOf("ipad") != -1 ||
          userAgent.indexOf("android") != -1 ||
          userAgent.indexOf("mobile") != -1 
      ) {
        isMobile.value = true
        return
      }
      
    
    router.beforeEach((to, from, next) => {

    
      if( to.path == "/" ){
        backgroundColor.value = "rgb(255, 230, 101)"
        backgroundImageSrc.value = require('./assets/login.jpg')
      }else if( to.path == "/accountList"){
        backgroundColor.value =  "rgb(153, 139, 175)"
        backgroundImageSrc.value = require('./assets/admin.jpg')
        titleImageSrc.value = require('./assets/korokoro_admin.png')
      }else if( to.path == "/catalogList" ){
        if( store.getters.getRole == "guest"){
          backgroundColor.value = "rgb(255, 230, 101)"
          backgroundImageSrc.value = require('./assets/user.jpg')
          titleImageSrc.value = require('./assets/korokoro_user.png')
        }else{
          backgroundColor.value =  "rgb(153, 139, 175)"
          backgroundImageSrc.value = require('./assets/admin.jpg')
          titleImageSrc.value = require('./assets/korokoro_admin.png')
        }
      }else if( to.path == "/sendMail"){
        backgroundColor.value =  "rgb(153, 139, 175)"
        backgroundImageSrc.value = require('./assets/admin.jpg')
        titleImageSrc.value = require('./assets/korokoro_admin.png')

      }else if( to.path == "/registNotice"){
        backgroundColor.value =  "rgb(153, 139, 175)" 
        backgroundImageSrc.value = require('./assets/admin.jpg')
        titleImageSrc.value = require('./assets/korokoro_admin.png')

      }
 
      if( to.path == "/"){
        next()
        return
      }
 
      if( !store.getters.getIsLogin ){
        router.push("/")
      }else{
        var role = store.getters.getRole
        if( role == "guest" && ( to.path == "/accountList" || to.path == "/sendMail" || to.path == "/registNotice") ){
          router.push("/authorityError")
        }else{
          next()
        }
      }
    })


    //ここでページ毎にヘッダー色を変える
    const trasPage = ( page ) => {
      if( page == "registNotice"){

        router.push("/registNotice")
      }
      else if( page == "sendMail"){

        router.push("/sendMail")
      }else if( page == "accountList"){

        router.push("/accountList")
      }else if( page == "catalogList"){

        router.push("/catalogList")
      }
    }

    const logout = ()=>{
      logoutAccount( callback )
    }
    

    const callback = ()=>{
      backgroundColor.value = "rgb(255, 230, 101)"
      router.push("/")
    }
    

    
    const viewChangePassword = () =>{
      isEdit.value = true
    }
    
    const setIsEdit = ( value ) => {
      isEdit.value = value;
    }
    
    return{
      logout,
      backgroundImageSrc,
      isEdit,
      setIsEdit,
      viewChangePassword,
      store,
      backgroundColor,
      trasPage,
      titleImageSrc,
      isMobile
    }
  }
})
</script>


<style>
#app {
    font-family: -apple-system,BlinkMacSystemFont,"Noto Sans JP",'Lato',

    "ヒラギノ角ゴ ProN","Hiragino Kaku Gothic ProN","ヒラギノ角ゴ Pro",

    "Hiragino Kaku Gothic Pro","メイリオ", Meiryo;

 

    -webkit-font-smoothing: antialiased;

    -moz-osx-font-smoothing: grayscale;

    text-align: center;

    color: #2c3e50;

    margin: 0 0;

    padding: 0 0;

    height: 100vh
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
body {
    margin: 0px;
    padding: 0px;
    height:100vh;
}
</style>
